import React, {Component} from 'react'
import { Card } from 'antd';

//import "style-loader!../../assets/css/pnpOs.css"


class PieContainer extends React.Component{
    constructor(props){
        super(props )
    }

    render(){
        return(

            <Card title={this.props.title} extra={<a href="#">More</a>} style={{ width: '100%' }}>
            <p>{this.props.body}</p>
           
          </Card>

            

        )
        
    }

}

export default PieContainer